import React, { Suspense, useEffect } from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";

import "./App.css";
import Login from "./containers/Login/Login";
import PartnerClientSelection from "./containers/Partner/PartnerSelection";
import LeftSideBar from "./hoc/LeftSideBar";
import Home from "./containers/Home/Home";
import MyAccount from "./components/MyAccount/MyAccount";
import ViewMyInfo from "./components/MyInformation/ViewMyInfo";
import ContactsList from "./containers/Contacts/ContactsList";
import EditMyInfo from "./containers/MyInformation/EditMyInfo";
import MyOffer from "./containers/Offer/MyOffer";
import BasePriceSetting from "./containers/Config/BasePriceSetting";
import MixSupply from "./containers/Config/MixSupply";
import FAQ from "./containers/FAQ/FAQ";
import ResetPasswordWrapper from "./containers/ResetPassword/ResetPasswordWrapper"; // Updated import
import ForgetPassword from "./containers/ForgetPassword/ForgetPassword";
import ChangePassword from "./containers/ChangePassword/ChangePassword";
import { Debug } from "./constants";

function App() {
  useEffect(() => {
    if (window.location.protocol === "http:") {
      console.log(
        "you are accessing us via " +
          "an insecure protocol (HTTP). " +
          "Redirecting you to HTTPS.",
      );
      console.log(window.location);

      if (window.location.host !== "localhost:3000") {
        window.location.href = window.location.href.replace("http:", "https:");
      }
    }
  });

  // Disable console log
  if (!Debug) {
    console.log = function () {};
  }
  return (
    <div className="App">
      <div
        id="leftsidebar"
        style={{
          display:
            window.location.hash === "#/" ||
            window.location.hash === "/" ||
            window.location.hash === ""
              ? "none"
              : "",
        }}
      >
        <LeftSideBar />
      </div>
      <Router>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route exact path="/" element={ <Login /> } />
            <Route exact path="/login" element={ <Login /> } />
            <Route exact path="/myaccount/login" element={ <Login /> } />
            <Route exact path="/forgetpassword" element={ <ForgetPassword /> } />
            <Route path="/userselection" element={ <PartnerClientSelection /> } />
            <Route path="/home" element={ <Home /> } />
            <Route path="/myaccount" element={ <MyAccount /> } />
            <Route path="/changepassword" element={ <ChangePassword /> } />
            <Route path="/myinformation" element={ <ViewMyInfo /> } />
            <Route path="/myoffer" element={ <MyOffer /> } />
            <Route path="/editmyinformation" element={ <EditMyInfo /> } />
            <Route path="/mycontacts" element={ <ContactsList /> } />
            <Route path="/basepricesetting" element={ <BasePriceSetting /> } />
            <Route path="/mixsupply" element={ <MixSupply /> } />
            <Route path="/faq" element={ <FAQ /> } />
            <Route path="/reset/:token" element={ <ResetPasswordWrapper /> } />
          </Routes>
        </Suspense>
        <div
          id="spinner"
          className="loaderContainer"
          style={{ display: "none" }}
        >
          <div className="loader" />
          Chargement
        </div>
      </Router>
    </div>
  );
}

export default App;
